export const ITEMS_AMOUNT_BEFORE_DISPLAYING_SEARCH = 8;
export const NO_GROUP = 'NO_GROUP';
